import React from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import { FilterNumbers } from '@/internal-app/pages/administration/icbsReportAdministration/filterNumbers'
import { ColumnBindings } from '@/internal-app/pages/administration/icbsReportAdministration/columnBindings'
import { IcbsReportVersionNumber } from '@/internal-app/pages/administration/icbsReportAdministration/icbsReportVersionNumber'

const IcbsReportAdministration = React.memo(() => {
  return <Main>
    <MainTop>
      <MainTopTitle>
        <Resx name='Menu.IcbsReportAdministration' />
      </MainTopTitle>
    </MainTop>
    <MainBody>
      <FilterNumbers />
      <ColumnBindings />
      <IcbsReportVersionNumber />
    </MainBody>
  </Main>
})

export { IcbsReportAdministration }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/icbsReportAdministration/index.js